<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "VideoAiConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'videoAiConfig:add',
        update: 'videoAiConfig:update',
        delete: 'videoAiConfig:delete',
        deleteBatch: 'videoAiConfig:deleteBatch'
      },
      url: {
        get: '/videoAiConfig/listByCondition',
        add: '/videoAiConfig/add',
        update: '/videoAiConfig/update',
        delete: '/videoAiConfig/delete/',
        delete_batch: '/videoAiConfig/deleteBatch',
        status: '/videoAiConfig/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'presenterId',
        label: '数字人ID',
        show: true,
        width: '',
      },{
        field: 'driverId',
        label: '模型ID',
        show: true,
        width: '',
      },{
        field: 'gender',
        label: '性别',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '女性',
            type: 'primary',
          }, {
            key: 1,
            value: '男性',
            type: 'warning',
          }]
        },
      },{
        field: 'imageUrl',
        label: '机器人图像路径',
        show: true,
        img: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '视频AI配置',
        updateTitle: '视频AI配置',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'presenterId',
          label: '数字人ID',
          type: 'input',
          placeholder: '数字人ID',
          rules: [{message: '请输入数字人ID', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'driverId',
          label: '模型ID',
          type: 'input',
          placeholder: '风格编号',
          rules: [{message: '请输入风格编号', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'gender',
          label: '性别',
          type: 'select',
          selectData: [{
            id: 0,
            name: '女性',
          }, {
            id: 1,
            name: '男性',
          },],
          placeholder: '请选择',
          rules: [{
            message: '请选择', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'imageUrl',
          label: '机器人图片路径',
          type: 'input',
          placeholder: '机器人图片路径',
          rules: [{message: '请输入机器人图片路径', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
